import { render, staticRenderFns } from "./PsRegisterExtraction.vue?vue&type=template&id=e6d6a426&scoped=true"
import script from "./PsRegisterExtraction.vue?vue&type=script&lang=js"
export * from "./PsRegisterExtraction.vue?vue&type=script&lang=js"
import style0 from "./PsRegisterExtraction.vue?vue&type=style&index=0&id=e6d6a426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d6a426",
  null
  
)

export default component.exports